import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { computeCardLabel, getLastDividerIndex } from "./helpers";

type UseInfoCardParams = {
  def: any; // Replace 'any' with the actual type if available
  data: any; // Replace 'any' with the actual type if available
  editable: boolean;
  onEdit?: () => void;
  hasChangeRequest?: boolean;
  defaultLabel?: string;
};

export const useInfoCard = ({
  def,
  data,
  editable,
  onEdit,
  hasChangeRequest,
  defaultLabel,
}: UseInfoCardParams) => {
  const { t, i18n } = useTranslation();
  const label = useMemo(() => computeCardLabel(def, data, t), [def, data, t]);
  const lastDivider = useMemo(
    () => getLastDividerIndex(def.children || []),
    [def.children],
  );

  return {
    def,
    data,
    editable,
    onEdit,
    hasChangeRequest,
    defaultLabel,
    t,
    i18n,
    label,
    lastDivider,
  };
};
